module.exports = __webpack_public_path__ + "static/media/payment-finish.a7c1601d.svg";